module.exports = __webpack_public_path__ + "img/dice1.a6ee6168.svg";